import { Button, Flex, FormControl, FormLabel, Grid, GridItem, Input, InputGroup, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay, Stack, Text, useToast } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { FORGOT_PASSWORD_MUTATION } from "../Graphql/Mutations";
import { useMutation } from "@apollo/client";
export function ResetPassword({ isOpen, onClose, onOpenLoginModal, onOpenForgotPasswordModal }) {
    const { control, handleSubmit, formState: { errors }, trigger, watch } = useForm();
    const [forgotPasswordQuery, forgotPassword] = useMutation(FORGOT_PASSWORD_MUTATION);
    let toast = useToast();
    const lableStyle = {
        color: "#315B84",
        fontSize: "0.9rem",
        fontWeight: "500",
        lineHeight: "2",
    };
    const fieldStyle = {
        backgroundColor: "#f3f3f3",
        padding: "12px 15px"
    };
    const onSubmit = (data) => {
        trigger().then(async (isValid) => {
            if (isValid) {
                try {
                    console.log(data);
                    const forgotPasswordInput = {
                        email: sessionStorage.getItem('email'),
                        OTP: sessionStorage.getItem('otp'),
                        newPassword: data.password,
                    }
                    console.log("change password input", forgotPasswordInput);
                    await forgotPasswordQuery({ variables: forgotPasswordInput });
                }
                catch (error) {
                    console.log("Error from calling forgot password mutation => ", error?.message);
                }
            }
        });

    };
    useEffect(() => {
        console.log("error:", forgotPassword?.error)
        console.log("loading:", forgotPassword.loading)
        console.log("data:", forgotPassword.data)
        if (forgotPassword.data != undefined) {
            if (forgotPassword?.data?.resetPassword?.success) {
                toast({
                    title: 'Succeed',
                    description: 'Password Changed Successfully',
                    status: 'success',
                    duration: 4000,
                    isClosable: true,
                    position: "bottom-left"
                });
                sessionStorage.removeItem('email');
                sessionStorage.removeItem('otp');
                onClose();
            }
            else {
                toast({
                    title: 'Error',
                    description: forgotPassword?.data?.resetPassword?.message,
                    status: 'error',
                    duration: 4000,
                    isClosable: true,
                    position: "bottom-left"
                });
                sessionStorage.removeItem('email');
                sessionStorage.removeItem('otp');
                onClose();
            }
        }
        if (forgotPassword.error != undefined) {
            toast({
                title: 'error',
                description: forgotPassword.error.message,
                status: 'error',
                duration: 4000,
                isClosable: true,
                position: "bottom-left"
            });
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('otp');
            onClose();
        }
    }, [forgotPassword.data, forgotPassword.loading, forgotPassword.error])
    return (
        <>
            <Modal
                isCentered
                isOpen={isOpen}
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent backgroundColor={"#ececec"}>
                    <ModalCloseButton mt={"18px"} size={"lg"} />
                    <ModalBody pb={6}>
                        <Flex
                            align={'center'}
                            justify={'center'}>
                            <Stack
                                spacing={4}
                                w={'full'}
                                maxW={'md'}
                                rounded={'xl'}
                                p={1}
                                my={5}>
                                <Text lineHeight={1.1} fontSize={"32px"} fontWeight={"500"}>
                                    Reset Password
                                </Text>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <FormControl id="password" mt={4}>
                                        <FormLabel {...lableStyle}>Password</FormLabel>
                                        <Controller
                                            name="password"
                                            control={control}
                                            defaultValue=""
                                            rules={{
                                                required: "Enter your password", minLength: {
                                                    value: 6,
                                                    message: "Password must be at least 6 characters long",
                                                }
                                            }}
                                            render={({ field }) => (
                                                <InputGroup>
                                                    <Input
                                                        {...field}
                                                        {...fieldStyle}
                                                        type={"password"}
                                                        placeholder="Enter your password"
                                                    />
                                                </InputGroup>
                                            )}
                                        />
                                        {errors.password && (
                                            <Text color="red">{errors.password.message}</Text>
                                        )}
                                    </FormControl>
                                    <FormControl id="confirmPassword" mt={4}>
                                        <FormLabel {...lableStyle}>Confirm Password</FormLabel>
                                        <Controller
                                            name="confirmPassword"
                                            control={control}
                                            defaultValue=""
                                            rules={{
                                                required: "Enter your confirm password",
                                                validate: (value) => {
                                                    if (!value) {
                                                        return "Enter Your confirm password";
                                                    }
                                                    if (value !== watch("password")) {
                                                        return "Password and confirm password do not match.";
                                                    }
                                                    return true;
                                                },
                                            }}
                                            render={({ field }) => (
                                                <InputGroup>
                                                    <Input
                                                        {...field}
                                                        {...fieldStyle}
                                                        type={"password"}
                                                        placeholder="Confirm Password"
                                                    />

                                                </InputGroup>
                                            )}
                                        />
                                        {errors.confirmPassword && (
                                            <Text color="red">{errors.confirmPassword.message}</Text>
                                        )}
                                    </FormControl>
                                    <Stack spacing={6} mt={"45px"}>
                                        <Button
                                            type="submit"
                                            bg={'#002B5B'}
                                            color={'white'}
                                            _hover={{ bg: "#002B5B" }}
                                            isLoading={forgotPassword?.loading}
                                        >

                                            Submit
                                        </Button>
                                    </Stack>
                                </form>
                            </Stack>
                        </Flex>
                    </ModalBody>
                    <ModalFooter>
                        <Grid templateColumns='repeat(5, 1fr)' gap={4}>
                            <GridItem col={6} >
                                <Button variant="ghost" onClick={() => {
                                    onClose()
                                    onOpenForgotPasswordModal()
                                }}>

                                    Change Email
                                </Button>
                            </GridItem>
                            <GridItem colEnd={6} onClick={() => {
                                onClose()
                                onOpenLoginModal()
                            }} >
                                <Button bg={'#002B5B'}
                                    color={'white'}
                                    _hover={{
                                        bg: '#002B5B',
                                    }} >
                                    Login Instead
                                </Button>
                            </GridItem>
                        </Grid>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}